import React from "react";

import { RightArrow } from "icons";

import { Button, Typography } from "clearsense-ui/components";
import useForceLightMode from "hooks/useForceLightMode";
import { HeroImage } from "images/LandingPage";

import Blogs from "./Blogs";
import Features from "./Features";
import Footer from "./Footer";
import Navigation from "./Navigation";
import Testimonial from "./Testimonial";

const LandingPage = ({ user }) => {
  useForceLightMode();

  return (
    <div className="block">
      <Navigation isLoggedIn={user && true} />
      <div className="hero-wrapper">
        <div className="flex justify-around gap-1 mx-20">
          <div className="space-y-10 headline-wrapper">
            <Typography style="jumbo" type="medium" className="font-serif">
              A next generation healthcare data platform.
            </Typography>
            <Typography style="h3">
              Convert your data into a single source of truth to accelerate data
              maturity, optimize analytics tools, improve decision quality and
              unlock meaningful outcomes.
            </Typography>
            <div>
              <Button
                className="text-white bg-gray-900 rounded-full shadow-2xl"
                href="/login"
                label="Learn How"
                style="secondary"
                icon={RightArrow}
                iconPosition="right"
              />
            </div>
          </div>
          <div
            className="mt-16 rounded-full ellipse"
            style={{
              backgroundImage: `url(${HeroImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "0 0 0 0",
            }}
          ></div>
        </div>
      </div>
      <Features />
      <Testimonial />
      <Blogs />
      <Footer showCTA />
    </div>
  );
};

export default LandingPage;
